import React, {
  createContext,
  useContext,
  useState,
  FunctionComponent,
  PropsWithChildren,
} from "react";

export type OpenedCheckboxElement = {
  name: string;
  element: "DATEPICKER" | "STATUS_DROPDOWN";
};

type TaskCheckboxContextValue = {
  openedCheckboxElement?: OpenedCheckboxElement;
  setOpenedCheckboxElement: (value: OpenedCheckboxElement) => void;
  setCheckboxClosed: () => void;
};

/**
 * The context permits to have one checkbox dropdown open at a time.
 */
const TaskCheckboxContext = createContext<TaskCheckboxContextValue>(undefined);

export const useTaskCheckboxContext = () => useContext(TaskCheckboxContext);

export const TaskCheckboxContextProvider: FunctionComponent<
  PropsWithChildren<{}>
> = ({children}) => {
  const [openedCheckboxElement, setOpenedCheckboxElement] = useState(undefined);

  const setCheckboxClosed = () => {
    setOpenedCheckboxElement(undefined);
  };

  return (
    <TaskCheckboxContext.Provider
      value={{
        openedCheckboxElement,
        setOpenedCheckboxElement,
        setCheckboxClosed,
      }}
    >
      {children}
    </TaskCheckboxContext.Provider>
  );
};
